module.exports = __webpack_public_path__ + "img/Arrow.f9132e19.svg";